"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.parse = parse, exports.Parser = void 0;
/**
* @module radspec/parser
*/

/**
* A token.
* @typedef {Object} Token
* @property {string} type The token type
* @property {*?} value The value of the token
*/

/**
* An AST node.
* @typedef {Object} Node
* @property {string} type The node type
*/

/**
* An AST.
* @typedef {Object} AST
* @property {string} type
* @property {Array<Node>} body The AST nodes
*/

/**
* Enum for parser state.
*
* @readonly
* @enum {string}
*/

var PARSER_STATE = {
  OK: "OK",
  ERROR: "ERROR"
};
/**
* Parses a token list into an AST.
*
* @class Parser
* @param {Array<Token>} tokens
* @property {string} state The state of the parser (`OK` or `ERROR`)
* @property {Array<Token>} tokens
* @property {number} cursor
*/

var Parser =
/*#__PURE__*/
function () {
  function Parser(tokens) {
    _classCallCheck(this, Parser);

    this.state = PARSER_STATE.OK, this.tokens = tokens, this.cursor = 0;
  }
  /**
  * Get the current token and increase the cursor by 1
  *
  * @return {Token}
  */


  _createClass(Parser, [{
    key: "consume",
    value: function consume() {
      return this.cursor++, this.tokens[this.cursor - 1];
    }
    /**
    * Get the previous token.
    *
    * @return {Token}
    */

  }, {
    key: "previous",
    value: function previous() {
      return this.tokens[this.cursor - 1];
    }
    /**
    * Get the token under the cursor without consuming it.
    *
    * @return {Token}
    */

  }, {
    key: "peek",
    value: function peek() {
      return this.tokens[this.cursor];
    }
    /**
    * Checks if the type of the next token matches any of the expected types.
    *
    * Increases the cursor by 1 if the token matches.
    *
    * @param {...string} expected The expected types
    * @return {boolean} True if the next token matches, otherwise false
    */

  }, {
    key: "matches",
    value: function matches() {
      if (this.eof()) return !1;

      for (var _len = arguments.length, expected = new Array(_len), _key = 0; _key < _len; _key++) {
        expected[_key] = arguments[_key];
      }

      for (var _i = 0, _expected = expected; _i < _expected.length; _i++) {
        var type = _expected[_i];
        if (this.peek().type === type) return this.cursor++, !0;
      }

      return !1;
    }
    /**
    * Try to parse comparison operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "comparison",
    value: function comparison(astBody) {
      var node = this.addition(astBody);

      for (; this.matches("GREATER", "GREATER_EQUAL", "LESS", "LESS_EQUAL", "EQUAL_EQUAL", "BANG_EQUAL");) {
        var operator = this.previous().type,
            right = this.addition(astBody);
        node = {
          type: "ComparisonExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return this.matches("QUESTION_MARK") && (node = {
        type: "TernaryExpression",
        predicate: node,
        left: this.comparison(astBody)
      }, !this.matches("COLON") && this.report("Half-baked ternary (expected colon)"), node.right = this.comparison(astBody)), this.matches("DOUBLE_VERTICAL_BAR") && (node = {
        left: node,
        right: this.comparison(),
        type: "DefaultExpression"
      }), node;
    }
    /**
    * Try to parse arithmetic operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "addition",
    value: function addition(astBody) {
      var node = this.multiplication(astBody);

      for (; this.matches("MINUS", "PLUS");) {
        var operator = this.previous().type,
            right = this.multiplication(astBody);
        node = {
          type: "BinaryExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return node;
    }
    /**
    * Try to parse binary operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "multiplication",
    value: function multiplication(astBody) {
      var node = this.power(astBody);

      for (; this.matches("SLASH", "STAR", "MODULO");) {
        var operator = this.previous().type,
            right = this.power(astBody);
        node = {
          type: "BinaryExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return node;
    }
    /**
    * Try to parse exponential operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "power",
    value: function power(astBody) {
      var node = this.unary(astBody);

      for (; this.matches("POWER");) {
        var operator = this.previous().type,
            right = this.unary(astBody);
        node = {
          type: "BinaryExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return node;
    }
    /**
    * Try to parse unary operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "unary",
    value: function unary(astBody) {
      if (this.matches("BANG", "MINUS")) {
        var operator = this.previous().type,
            right = this.unary(astBody);
        return {
          type: "UnaryExpression",
          operator: operator,
          right: right
        };
      }

      return this.identifier(astBody);
    }
    /**
    * Try to parse identifiers and call expressions.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "identifier",
    value: function identifier(astBody) {
      var node;

      if (this.matches("IDENTIFIER") && (node = {
        type: "Identifier",
        value: this.previous().value
      }), !node) {
        var previousNode = astBody.length && astBody[astBody.length - 1];
        previousNode && ("Identifier" === previousNode.type || "GroupedExpression" === previousNode.type || "CallExpression" === previousNode.type) && (node = previousNode, astBody.pop());
      }

      if (node) {
        for (; this.matches("DOT");) {
          var property = this.consume().value;
          node = {
            type: "PropertyAccessExpression",
            target: node,
            property: property
          };
        }

        return this.matches("LEFT_PAREN") && (node = {
          type: "CallExpression",
          target: node.target,
          callee: node.property,
          inputs: this.functionInputs(astBody),
          outputs: []
        }, this.eof() && this.report("Unterminated call expression"), node.outputs = this.typeList()), node;
      }

      return this.helper(astBody);
    }
    /**
    * Try to parse helper functions
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "helper",
    value: function helper(astBody) {
      if (this.matches("AT")) {
        var identifier = this.consume(),
            name = identifier.value;
        "IDENTIFIER" !== identifier.type && this.report("Invalid helper function name '".concat(name, "' provided after @"));
        var node = {
          type: "HelperFunction",
          name: name
        };
        return this.matches("LEFT_PAREN") ? node.inputs = this.functionInputs(astBody) : this.report("Expected '(' for executing helper function"), node;
      }

      return this.primary(astBody);
    }
    /**
    * Try to parse primaries (literals).
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "primary",
    value: function primary() {
      if (this.matches("NUMBER", "STRING", "HEXADECIMAL", "BOOLEAN")) {
        var type = {
          NUMBER: "NumberLiteral",
          STRING: "StringLiteral",
          HEXADECIMAL: "BytesLiteral",
          BOOLEAN: "BoolLiteral"
        }[this.previous().type];
        return {
          type: type,
          value: this.previous().value
        };
      }

      if (this.matches("LEFT_PAREN")) {
        var expression;

        do {
          // Keep munching expressions in the context of the current expression
          expression = this.comparison(expression ? [expression] : []);
        } while (!this.eof() && !this.matches("RIGHT_PAREN"));

        return this.eof() && this.report("Unterminated grouping"), {
          type: "GroupedExpression",
          body: expression
        };
      }

      this.report("Unknown token \"".concat(this.consume().type, "\""));
    }
    /**
    * Try to parse a type.
    *
    * @return {string} The type
    */

  }, {
    key: "type",
    value: function type() {
      return this.matches("COLON") || "TYPE" === this.peek().type || this.report("Expected a type, got \"".concat(this.peek().type, "\"")), this.consume().value;
    }
    /**
    * Try to parse a type list.
    *
    * @return {Array<string>} The list of types
    */

  }, {
    key: "typeList",
    value: function typeList() {
      // We just have a single type
      if (this.matches("COLON") || "TYPE" === this.peek().type && "LEFT_PAREN" === this.peek().type || this.report("Expected a type or a list of types, got \"".concat(this.peek().type, "\"")), !this.matches("LEFT_PAREN")) return [{
        type: this.consume().value,
        selected: !0
      }];
      var typeList = [];

      for (; !this.eof() && !this.matches("RIGHT_PAREN");) {
        // Check if the type is preceded by a < to denote
        // that this is the type of the return value we want.
        var selected = this.matches("LESS");
        "TYPE" === !this.peek().type && this.report("Unexpected identifier in type list, expected type, got \"".concat(this.peek().type, "\"")), typeList.push({
          type: this.consume().value,
          selected: selected
        }), selected && !this.matches("GREATER") && this.report("Unclosed selected type"), this.matches("COMMA") || "RIGHT_PAREN" === this.peek().type || this.report("Undelimited parameter type (expected comma delimiter or closing brace)");
      }

      this.eof() && this.report("Unclosed type list"); // Verify that at least one type in the type list has been selected
      // as the type of the return value.
      //
      // If no type has been selected, and the number of types in the type
      // list is exactly 1, then we assume that that type should be
      // marked as selected.

      var hasSelectedTypeInList = !!typeList.find(function (item) {
        return item.selected;
      });
      return hasSelectedTypeInList || 1 !== typeList.length ? !hasSelectedTypeInList && this.report("Type list has no selected type") : typeList[0].selected = !0, typeList;
    }
    /**
    * Try to parse function arguments.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Array<Node>}
    */

  }, {
    key: "functionInputs",
    value: function functionInputs(astBody) {
      var inputs = [];

      for (; !this.eof() && !this.matches("RIGHT_PAREN");) {
        var input = this.comparison(astBody);
        input.type ? this.matches("COLON") && this.report("Unexpected type (already inferred type of parameter)") : input.type = this.type(), inputs.push(input), this.matches("COMMA") || "RIGHT_PAREN" === this.peek().type || this.report("Undelimited parameter type (expected comma delimiter or closing brace)");
      }

      return inputs;
    }
    /**
    * Walk all possible paths and try to parse a single node
    * from the list of tokens.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "walk",
    value: function walk(astBody) {
      var token = this.peek();
      if ("MONOLOGUE" === token.type) return {
        type: "MonologueStatement",
        value: this.consume().value
      };

      if ("TICK" === token.type) {
        var node = {
          type: "ExpressionStatement",
          body: []
        };

        for (this.matches("TICK"); !this.eof() && "TICK" !== this.peek().type;) {
          node.body.push(this.walk(node.body));
        }

        return this.eof() && this.report("Unterminated expression"), this.matches("TICK"), node;
      }

      return this.comparison(astBody);
    }
    /**
    * Walks the token list and returns an AST.
    *
    * @return {AST} The AST
    */

  }, {
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var ast;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ast = {
                  type: "Program",
                  body: []
                };

                for (; !this.eof();) {
                  ast.body.push(this.walk(ast.body));
                }

                return _context.abrupt("return", this.state === PARSER_STATE.ERROR ? (console.error("Errors encountered while parsing source"), ast) : ast);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function parse() {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
    /**
    * Returns true if we've reached the end of the token list, otherwise false.
    *
    * @return {boolean}
    */

  }, {
    key: "eof",
    value: function eof() {
      return this.cursor >= this.tokens.length;
    }
    /**
    * Prints an error with location information to `stderr`
    * and sets the parser state to `PARSER_STATE.ERROR`
    *
    * @param {string} error
    * @return {void}
    */

  }, {
    key: "report",
    value: function report(error) {
      this.state = PARSER_STATE.ERROR, console.error("Error (".concat(this.cursor, "): ").concat(error));
    }
  }]);

  return Parser;
}();
/**
* Walks token list and returns an AST.
*
* @memberof radspec/parser
* @param  {Array<Token>} tokens
* @return {AST} The AST
*/


exports.Parser = Parser;

function parse(tokens) {
  return new Parser(tokens).parse();
}